module.exports = __webpack_public_path__ + "img/jilu.1b2585a2.png";